module.exports = __webpack_public_path__ + "img/napravlen-mobile-3.e8e44afd.png";